import Layout from './layout/Layout'
import './css/adminlte.css'
import './css/App.css'


function App(props = {}) {
  return (
      <Layout {...props} />
  )
}

export default App
